<template>
  <ClientFilter :id="id" v-model="modelValue.ownerNaturalIds" />
</template>

<script lang="ts" setup>
import { PropType, toRefs } from 'vue';

import { ManifestSearchCriteria } from '@/model';

import ClientFilter from '@/components/search/ClientFilter.vue';

const modelValue = defineModel({
  type: Object as PropType<ManifestSearchCriteria>,
  required: true,
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);
</script>
